import type { VersandFormatStufe, VersandRegelWerte } from "@/api/versandregel";

export interface VersandStufenEntwurf { abMenge: string; format: VersandFormatStufe["format"] }
const rang = (format: VersandFormatStufe["format"]) => format === "paket" ? 2 : 1;

/** Alte Paketschwelle und neue Staffel gemeinsam ohne Wirkungsverlust bearbeiten. */
export function staffelEntwurf(regel: VersandRegelWerte | null): VersandStufenEntwurf[] {
  const alle = [...(regel?.formatStufen ?? [])];
  if (regel?.paketAbMenge != null) alle.push({ abMenge: regel.paketAbMenge, format: "paket" });
  alle.sort((a, b) => a.abMenge - b.abMenge || rang(b.format) - rang(a.format));
  let staerkste = 0;
  return alle.filter(s => {
    if (rang(s.format) <= staerkste) return false;
    staerkste = rang(s.format);
    return true;
  }).map(s => ({ abMenge: String(s.abMenge), format: s.format }));
}

export function staffelGueltig(stufen: VersandStufenEntwurf[]): boolean {
  return stufen.length <= 20 && stufen.every((s, i) => {
    const menge = Number(s.abMenge);
    return Number.isInteger(menge) && menge >= 1 && menge <= 1000
      && (i === 0 || (menge > Number(stufen[i - 1]!.abMenge) && rang(s.format) > rang(stufen[i - 1]!.format)));
  });
}
